import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import renderHTML from 'react-render-html';
import I18, { i18Get } from '../../i18';
import { getTrans } from '../../kado/utils';
import Likertoptions from './ass-components/likertoptions';

import '../../kado/css';
import './likertScale.css';
import { isTabletView } from '../../kado/md/components/utils';
import LikertTabletOptions from './ass-components/likertTabletOptions';

class LikertScale extends Component {
    constructor(props) {
        super(props);
        this.state = {
           questions: []
        };
    }   

    getAnswerForQuestion(questionId) {
        var answers = this.props.answers;
        var answerForQuestion = {};
        if(answers && answers.length > 0) {
            answers.map(answer => {
                if(answer.question === questionId){
                    answerForQuestion = answer;
                }
            });
        }
        return answerForQuestion;
    }

    getSubQuestions(question) {
        var subQstnArray = []
        if(question.ansType === 'o' || question.ansType === 'm') {
            const answer = this.getAnswerForQuestion(question.uuid)
            question.options.map((option) => {
                if(option.uuid ===  answer.option || (typeof answer.mOptions !== 'undefined' && answer.mOptions.indexOf(option.uuid) !== -1)) {
                    if(option.section) {
                        subQstnArray.push(<div style={{border: 'none'}} className="section_title" >{renderHTML(this.getSection(option.section))}</div>)
                        subQstnArray  = [...subQstnArray, ...this.renderQuestions(option.section)] 
                    }
                }
            })
        }
        return subQstnArray
    }

    renderQuestions(section) {
        var qstnsArray = []
    }
    optionColours(number){
        var colour = []
        switch (number) {
            case 2 : colour[0] ='rgb(255,158,195)'
                     colour[1] = 'rgb(185,222,255)'
                     break;
            case 3:  colour[0] ='rgb(255,158,195)'
                     colour[1] = 'rgb(255,251,156)'
                     colour[2] = 'rgb(185,222,255)'
                     break;
            case 4: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,205,176)'
                    colour[2] = 'rgb(220,237,230)'
                    colour[3] = 'rgb(185,222,255)'
                    break;
            case 5: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,205,176)'
                    colour[2] = 'rgb(255,251,156)'
                    colour[3] = 'rgb(220,237,230)'
                    colour[4] = 'rgb(185,222,255)'
                    break;
            case 6: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,182,186)'
                    colour[2] = 'rgb(225,228,166)'
                    colour[3] = 'rgb(238,244,212)'
                    colour[4] = 'rgb(203,230,249)'
                    colour[5] = 'rgb(185,222,255)'
                    break;
            case 7: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,182,186)'
                    colour[2] = 'rgb(255,228,166)'
                    colour[3] = 'rgb(255,251,156)'
                    colour[4] = 'rgb(238,244,212)'
                    colour[5] = 'rgb(203,230,249)'
                    colour[6] = 'rgb(185,222,255)'
                    break;
            case 8: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,182,186)'
                    colour[2] = 'rgb(255,228,166)'
                    colour[3] = 'rgb(255,240,161)'
                    colour[4] = 'rgb(247,248,184)'
                    colour[5] = 'rgb(255,251,156)'
                    colour[6] = 'rgb(238,244,212)'
                    colour[7] = 'rgb(185,222,255)'
                    break;
            case 9: colour[0] ='rgb(255,158,195)'
                    colour[1] = 'rgb(255,182,186)'
                    colour[2] = 'rgb(255,228,166)'
                    colour[3] = 'rgb(255,240,161)'
                    colour[4] = 'rgb(255,251,156)'
                    colour[5] = 'rgb(247,248,184)'
                    colour[6] = 'rgb(255,251,156)'
                    colour[7] = 'rgb(238,244,212)'
                    colour[8] = 'rgb(185,222,255)'
                    break;
            case 10: colour[0] ='rgb(255,158,195)'
                     colour[1] = 'rgb(255,182,186)'
                     colour[2] = 'rgb(255,228,166)'
                     colour[3] = 'rgb(255,240,161)'
                     colour[4] = 'rgb(255,246,159)'
                     colour[5] = 'rgb(251,250,170)'
                     colour[6] = 'rgb(247,248,184)'
                     colour[7] = 'rgb(255,251,156)'
                     colour[8] = 'rgb(238,244,212)'
                     colour[9] = 'rgb(185,222,255)'
                     break;
        }
        return colour
    }

    getSection(section){
        return getTrans(section,'title')
    }

    render() {
        var Data = []
        if(this.props.questions.length) {
            this.state.questions = this.props.questions;  
        }
        this.state.questions.map((q, index) => {
            var opt = [];
            var optcol = []
            var colours = this.props.section.likertscaletype.colour_schema === true && this.optionColours(this.props.section.likertscaletype.options.length)
            var sortedOptions = _.orderBy(this.props.section.likertscaletype.options,'order','asc')
            sortedOptions.forEach((o,index) => {
                opt.push(getTrans(o,'title'));
                colours && colours.length !== 0 && optcol.push(colours[index])
            });
            
            if(this.props.section.likertscaletype.startwithblue) {
                optcol.reverse()
            }
            if(this.props.section.likertscaletype.not_applicable) {
                opt.push(this.props.section.likertscaletype.not_applicable_text !== null ? getTrans(this.props.section.likertscaletype,'not_applicable_text') : i18Get('Not Applicable'));
                if(this.props.section.likertscaletype.colour_schema) {
                    optcol.push('#FAF7F7');
                }
            }

            Data = {
                section_title :getTrans(this.props.section,'general_question_headline'),
                option_title : opt,
                color : optcol,
                questions : this.props.questions
            }
        })

        const optionTitleLength = Data.length ? Data.option_title.length : 0;
        const widthPercentage = (100 / optionTitleLength)-(34/optionTitleLength);
        const selectedAss = _.find(this.props.assessments.assList, 'selected');

        return (
            <div>
            
             {this.props.section.section_type !== 'l' ?
                  
                <div key={this.props.questions.uuid} className="section_box">
                    <div className="section_title">{renderHTML(this.getSection(this.props.section))}</div>
                    <div className="section_question">{this.renderQuestions(this.props.section)}</div>
                </div>

                :
                isTabletView() ?
                <div>
                  {this.props.questions.map((question, index) => (
                    <div className='quest-section'>
                      {this.props.show_question_order && <label>{question.order} out of {this.props.qlength}</label>}
                      <LikertTabletOptions
                        key={question.uuid}
                        question={question}
                        likertType={this.props.questions}
                        qstnr={this.props.questions.questionnaire}
                        assessment={this.props.assessment}
                        questionnaire={this.props.section.questionnaire}
                        answer={this.getAnswerForQuestion(question.uuid)}
                        documented={this.props.documented}
                        index={index}
                        show_question_order={this.props.show_question_order}
                        data={Data}
                      />
                    </div>
                  )
    
                  )}
                </div>
                :
                <div key={this.props.section.uuid} className="section_box likert-section">
                   <div className="likert-table-view">
                   <div className={` likert-table-div ${this.props.questions.length > 10 ? "large" : ""}`}>
                    <table className='table likert-sec-table'>
                        <thead>
                            <tr>
                                <th scope="col" style={{width:'34%'}}>{Data.section_title !== null ? Data.section_title:''}</th>
                                    {Data.option_title.map((option, ind) => (
                                        <th key={ind} scope="col" style={{backgroundColor: Data.color[ind],textAlign:'center',width:`${widthPercentage}%`}}>{renderHTML(option)}</th>
                                    ))}
                            </tr>
                        
                        </thead>
                        <tbody>
  
                            {this.props.questions.map((question,index) => (
                                    <Likertoptions 
                                        key={question.uuid} 
                                        question={question} 
                                        likertType = {this.props.questions}
                                        qstnr={this.props.questions.questionnaire}
                                        assessment={this.props.assessment} 
                                        questionnaire={this.props.section.questionnaire}
                                        answer={this.getAnswerForQuestion(question.uuid)}
                                        documented={this.props.documented}
                                        index = {index}
                                        show_question_order = {this.props.show_question_order}
                                    />
                                )

                            )}
                        </tbody>
                    </table>

                  </div>
                  </div>

                </div>
            }
        </div>
    )}
}
export default connect(state => ({
    assessments: state.assessments,
    translations: state.translations,
}))(LikertScale);
